import { render, staticRenderFns } from "./purchaseIntervals.vue?vue&type=template&id=0e33f15e&"
import script from "./purchaseIntervals.vue?vue&type=script&lang=ts&"
export * from "./purchaseIntervals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports